import SignUp from "@iso/containers/Pages/SignUp/SignUp";
import SignIn from "@iso/containers/Pages/SignIn/SignIn";
import ResendEmailConfirm from "@iso/containers/Pages/ResendEmailConfirm/ResendEmailConfirm";
import ForgotPassword from "@iso/containers/Pages/ForgotPassword/ForgotPassword";
import ResetPassword from "@iso/containers/Pages/ResetPassword/ResetPassword";
import VerifyPage from "@iso/containers/Pages/VerifyPage/VerifyPage";
import VisitorForm from "@iso/containers/Pages/VisitorForm/VisitorForm";
import PropertyCheckinLanding from "@iso/containers/Pages/PropertyCheckin/PropertyCheckinLanding";
import DivisionContactConfirm from "@iso/containers/Pages/DivisionContact/DivisionContactConfirm";
import PublicInduction from "@iso/containers/Pages/VisitorInduction/PublicInduction";
import StopDeviceAlarmRequest from "@iso/containers/Pages/StopDeviceAlarmRequest/StopDeviceAlarmRequest";
import VerifyElapsedPage from "@iso/containers/Pages/VerifyElapsedPage/VerifyElapsedPage";
import InvitationConflict from "@iso/containers/Pages/InvitationConflict/InvitationConflict";
import ThankYou from "@iso/containers/Pages/ThankYou/ThankYou";
import DeepLinkRedirect from "@iso/containers/Pages/DeepLink/DeepLinkRedirect";
import SafefarmRespond from "@iso/containers/Pages/SafefarmRespond/SafefarmRespond";

export default {
  Landing: {
    component: SignUp,
    path: "/",
  },
  SignUp: {
    component: SignUp,
    path: "/signup",
  },
  SignIn: {
    component: SignIn,
    path: "/signin",
  },
  ResendEmailConfirm: {
    component: ResendEmailConfirm,
    path: "/resendemail",
  },
  ForgotPassword: {
    component: ForgotPassword,
    path: "/forgotpassword",
  },
  ResetPassword: {
    component: ResetPassword,
    path: "/resetpassword",
  },
  VerifyPage: {
    component: VerifyPage,
    path: '/verify'
  },
  VisitorForm: {
    component: VisitorForm,
    path: '/visitor-form'
  },
  // Same page as /visitor-form, on its own path so the app-link files can send
  // contractor QRs to the Contractor app and visitor QRs to the Visitor app.
  ContractorForm: {
    component: VisitorForm,
    path: '/contractor-form'
  },
  PropertyCheckin: {
    component: PropertyCheckinLanding,
    path: '/property-checkin'
  },
  DivisionContactConfirm: {
    component: DivisionContactConfirm,
    path: '/division-contact/confirm'
  },
  VisitorInduction: {
    component: PublicInduction,
    path: '/visitor-induction'
  },
  StopDeviceAlarmRequest: {
    component: StopDeviceAlarmRequest,
    path: '/stop-device-alarm-request'
  },
 
  VerifyElapsedPage: {
    component: VerifyElapsedPage,
    path: "/sar-elapsed-time",
  },
  InvitationConflict: {
    component: InvitationConflict,
    path: "/invitation-conflict",
  },
  ThankYou: {
    component: ThankYou,
    path: "/thank-you",
  },
  DeepLinkRedirect: {
    component: DeepLinkRedirect,
    path: "/l/:type/:id",
  },
  SafefarmRespond: {
    component: SafefarmRespond,
    path: "/sf-respond/:token",
  },
};
